import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
const Login = () => {
  const { loginWithRedirect } = useAuth0();

  return <button class="btn btn-outline-success lgs" onClick={() => loginWithRedirect()}>Log In</button>;
};

export default Login;
